import { GenericObject, copyFields } from '@synergy/models';

import { ProductSnapshot } from '../../../common/models/product-snapshot';

export class SalesOrderPositionItem extends ProductSnapshot {
    public id?: number;
    public comment!: string;

    public static fromPlainObject(object: GenericObject): SalesOrderPositionItem {
        const item = new SalesOrderPositionItem();

        // Import own keys
        copyFields(object, item);

        // Import from base class (snapshot)
        const productSnapshot = ProductSnapshot.fromPlainObject(object);

        // Overwrite intersecting keys with base keys
        copyFields(productSnapshot, item);

        return item;
    }
}
